module.exports = __webpack_public_path__ + "static/media/shippers.31536c23.svg";